<template>
  <v-row>
    <template v-if="isErrorsCorrectionInaccuracies || isErrorsCorrectionWrongRegistered">
      <v-col class="pb-0 pt-0" cols="12" md="12" lg="12">
          <el-simple-table :items="dataList" />
        </v-col>
    </template>
      <template v-else>
        <v-col v-if="!isRegistrar" class="pb-0 pt-0" cols="12" md="12" lg="12">
          <el-autocomplete v-if="selectIntitutionEnabled"
              required
              direct
              :disabled="onlyView"
              :items="list"
              itemvalue="representitive_amn_id"
              itemtext="representitive_fullname"
              label="Duomenų teikėjas"
              v-model="dataProviderAmnId"
              @change="selectDataProvider()"
              validateKey="not_registrar_data_provider_amn_id"
            />
          <el-simple-table :items="dataList" />
        </v-col>
        <template v-if="isRegistrar">
          <v-col style="display: inline-flex;" class="pb-0 pt-0" cols="12" md="6" lg="3">
            <el-autocomplete
              required
              :disabled="onlyView"
              :items="classifiers['court']"
              itemvalue="value"
              itemtext="text"
              label="Institucijos pavadinimas"
              v-model="formData.data_provider_amn_id"
              validateKey="is_registrar_data_provider_amn_id"
            />
        </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <el-text-field
            disabled
            label="Institucijos kodas"
            v-model="code"
          />
        </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="6">
          <el-text-field
            disabled
            label="Institucijos adresas"
            v-model="address"
          />
        </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <el-text-field
            :disabled="onlyView"
            label="Pareigos"
            v-model="formData.representitive_position"
            :maxlength="200"
          />
        </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <el-text-field
            :disabled="onlyView"
            label="Vardas"
            v-model="formData.representitive_name"
            :maxlength="200"
          />
        </v-col>
          <v-col class="pb-0 pt-0" cols="12" md="6" lg="3">
          <el-text-field
            :disabled="onlyView"
            label="Pavardė"
            v-model="formData.representitive_lastname"
            :maxlength="200"
          />
        </v-col>
        </template>
    </template>
  </v-row>
</template>

<script>
import Roles from '@/components/constants/roles'
import userRole from '@/mixins/userRole'
import InJournalTypes from '@/components/constants/inJournalTypes'

export default {
  name: 'DataProvider',
  mixins: [userRole],
  components: {},
  props: {
    dataProviderType: [String],
    list: [Array, Object],
    formData: [Array, Object],
    onlyView: Boolean,
    inJournalType: [String],
  },
  data() {
    return {
      InJournalTypes: InJournalTypes,
      Roles: Roles,
      dataProviderAmnId: null,
      classifiers: {},
    }
  },
  created() {
    this.isRegistrar && this.getClassifiers()
    this.dataProviderAmnId = this.formData.representitive_amn_id
  },
  computed: {
    selectIntitutionEnabled() {
      return this.list.length > 0;
    },
    code(){
      if (this.dataProviderType == 'court') {
        let obj = this.getCurObj()
        return obj.code
      }

      return this.formData.code
    },
    address(){
      if (this.dataProviderType == 'court') {
        let obj = this.getCurObj()
        return obj.address
      }

      return this.formData.adr_text
    },
    isErrorsCorrectionInaccuracies() {
      return this.inJournalType == InJournalTypes.TARNYBINIS_APIE_NETIKSLUMUS
    },
    isErrorsCorrectionWrongRegistered() {
      return this.inJournalType == InJournalTypes.TARNYBINIS_APIE_KLAIDINGAI_IREGISTRUOTA
    },
    isRegistrar(){
      if (this.hasRole([Roles.TEISMAS])) {
         return false
      }
      if (this.hasRole([Roles.IR_REGISTRATORIUS, Roles.IR_ADMINISTRATORIUS, Roles.IR_KAC_DARBUOTOJAS,Roles.IR_RC_darbuotojas])) {
         return true
      }
      return false
    },
    dataList() {
      return [
        {
          title: 'Institucijos pavadinimas',
          value: this.formData.fullname,
        },
        {
          title: 'Institucijos kodas',
          value: this.formData.code,
        },
        {
          title: 'Institucijos adresas',
          value: this.formData.adr_text,
        },
        {
          title: 'Pareigos',
          value: this.formData.representitive_position,
        },
        {
          title: 'Vardas',
          value: this.formData.representitive_name,
        },
        {
          title: 'Pavardė',
          value: this.formData.representitive_lastname,
        },
      ]
    },
  },
  methods:{
    getCurObj(){
      if(this.dataProviderType == 'court' && this.formData.data_provider_amn_id && this.classifiers['court']) {
         return this.classifiers['court'].lt.filter((item) => item.value === this.formData.data_provider_amn_id)[0]
      }
      return {}
    },
    selectDataProvider() {
      if (this.dataProviderAmnId) {
        let item = this.list.find((item) => item.representitive_amn_id == this.dataProviderAmnId || item.representitive_amn_id == this.formData.data_provider_amn_id)
        this.$emit('setDataProvider', item)
      }
    },
    hasRole(roles) {
      const userRole = this.$store.getters.userRole
      return roles.some((item) => {
        return userRole.includes(item)
      })
    },
    getClassifiers() {
      let requiredClassifiers = { classifiers: ['court'] }
      this.$axios
        .post(`classifiers`, requiredClassifiers)
        .then((res) => {
          this.classifiers = res.data.classifiers
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
  }
}
</script>

<style>
</style>
